export interface IBillingDetails {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    unit?: string;
    zip: string;
    country: string;
}

export interface IPaymentFormData {
    firstName: string;
    lastName: string;
    preferred?: boolean;
    withDefaultPayment?: boolean;
    cardNumber: string | '';
    expirationDate: string;
    cvv: string | '';
    zip?: string;
    hasDifferentBillingAddress: number;
    billingDetails: IBillingDetails;
}

export const paymentFormInitialBillingDetails: IBillingDetails = {
    addressLine1: '',
    addressLine2: '',
    unit: '',
    city: '',
    state: '',
    zip: '',
    country: ''
};

export const paymentFormInitialValues: IPaymentFormData = {
    firstName: '',
    lastName: '',
    cardNumber: '',
    expirationDate: '',
    cvv: '',
    hasDifferentBillingAddress: 1,
    billingDetails: paymentFormInitialBillingDetails,
    preferred: true
};

export interface ReviewCompleteForm extends IPaymentFormData {
    nowOrLater: 'now' | 'later' | null;
    base64EncodedImage: string;
    acceptSubmitting: boolean;
}
